import type { EGameType } from '../../../types/enums'
import { Tabs } from '..'
import { gameTypeName } from './constants'
import { gameTypeTab, gameTypeTabs, gameTypeTabsWrapper } from './index.css'

export const GameTypeTabs = (props: {
  gameType: EGameType
  onChange: (gameType: EGameType) => void
}) => {
  return (
    <Tabs
      tabs={gameTypeName}
      selectedTab={props.gameType}
      classNameWrapper={gameTypeTabsWrapper}
      classNameTabList={gameTypeTabs}
      classNameTab={gameTypeTab}
      onChange={(type) => props.onChange(type)}
    />
  )
}
